import { Pipe, PipeTransform } from '@angular/core';
import { getSafe } from 'helpers';
import { AddressPipe } from './address.pipe';
import { TagType } from 'generated/graphql';
/*
 * Capitalizes the first letter of a string.
*/
@Pipe({ name: 'tagSelectLabel' })
export class TagSelectLabelPipe implements PipeTransform {
  transform(value: any): string {
    return getSafe(() => this.getText(value), '');
  }

  private getText(tag: any) {
    const name = tag.name;
    if (tag.tagType === TagType.Address) {
      const address = new AddressPipe().transform((tag).address);
      return `${name} - ${address}`;
    }

    return name;
  }
}
